import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import errorIcon from '../../assets/images/error-image.svg';
import styles from './content-error.module.scss';

const ContentError = ({ className, title, children }) => (
  <div className={cn(styles.container, className)}>
    <img src={errorIcon} alt='error' className={styles.errorIcon} />
    <div className={styles.errorTitle}>{title || 'Error'}</div>
    <div className={styles.errorText}>{children}</div>
  </div>
);

ContentError.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node,
};

ContentError.defaultProps = {
  className: '',
  title: '',
  children: null,
};

export default ContentError;
